import { Injectable } from '@angular/core';
import { DataResponseHttp } from '../../../http-models/data-response.http';
import { DataResponseModel } from '../../../models/apis/data-response.model';
import { BaseMapperWithSerializer } from '../../base.mapper';
import { GetHospitalsLitePaginatedModel } from '../../../models/apis/system/hospital/get-hospitals-lite-paginated.model';
import { HospitalLiteQueryHttp } from '../../../http-models/systems/hospital/hospital-lite-query.http';
import { HospitalLiteQueryModel } from '../../../models/apis/system/hospital/hospital-lite-query.model';
import { HospitalLiteModel } from '../../../models/apis/system/hospital/hospital-lite.model';

@Injectable({
    providedIn: 'root',
})
export class GetHospitalsLitePaginatedMapper
    implements
    BaseMapperWithSerializer<
            GetHospitalsLitePaginatedModel,
            string,
            DataResponseModel<HospitalLiteQueryModel>,
            DataResponseHttp<HospitalLiteQueryHttp>
        >
{
    convertTo(model: GetHospitalsLitePaginatedModel): string {
        let request = `?PageIndex=${model.pageIndex}&PageSize=${model.pageSize}`;
        request += `&IsActive=${model.isActive}`;
        if(model.userId){
            request += `&UserId=${model.userId}`;
        }
        if(model.hospitalIds && model.hospitalIds.length>0){
            model.hospitalIds.forEach(value => {
                request += `&HospitalIds=${value}`;
            });
        }
        return request;
    }

    convertFrom(
        http: DataResponseHttp<HospitalLiteQueryHttp>
    ): DataResponseModel<HospitalLiteQueryModel> {

        let response = {
            isError: http.isError,
            errors: http.errors
        } as DataResponseModel<HospitalLiteQueryModel>;
        if(http.isError!=true && http.data){

            response.data = {
                pageIndex: http.data.pageIndex,
                pageSize: http.data.pageSize,
                totalPages: http.data.totalPages,
                totalRecords: http.data.totalRecords,
                isNextPageAvailable: http.data.isNextPageAvailable,
                isActive: http.data.isActive,
                hospitalIds: http.data.hospitalIds,
                userId: http.data.userId,
                hospitals: []
            } as HospitalLiteQueryModel;

            for(let itemHttp of http.data.hospitals){
              let itemModel = {} as HospitalLiteModel;
              itemModel.id = itemHttp.id;
              itemModel.name = itemHttp.name;
              response.data.hospitals.push(itemModel);
            }
        }
        return response;
    }
}
